import "babel-polyfill"
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "@/assets/css/reset.styl" // 引入css重置

import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
Vue.use(Antd)

import "@/assets/css/common.styl"


import VueAwesomeSwiper from 'vue-awesome-swiper'
import "@/assets/css/swiper.css"
Vue.use(VueAwesomeSwiper)


// document.title = "青岛盛世富鞋业有限公司"
import qs from 'qs'
Vue.prototype.$qs = function(data) {
    // 在页面中使用的时候为this.$qs(对象)
    return qs.stringify(data)
}
// rem全局缩放
import {resize,localLanguageVal} from "@/utils/autoScale";
resize()
window.onresize = function (){resize()}



let onceEvent = true //用于避免不停点击路由跳转而产生错误
Vue.prototype.routerSkip = function(routerPath) {
    // 传入的第一个路径参数会替换当前最后一个路径参数 如果原来路径为*/a 传入的为b/c，则url替换为*/b/c 因此需要用相对路径进行控制
    // 参数对象的属性需要在router中命名/:参数 可选参数则为/:参数?
    // 跳转后的取值为this.$route.params

    let localLanguage=localLanguageVal()
    // console.log(localLanguage)
    if (onceEvent) {
        if (arguments.length > 1) {
            let paramsStr = ''
            for (let index in arguments) {
                if (index > 0) {
                    encodeURIComponent(arguments[index])
                    let str = '/' + arguments[index]
                    paramsStr += str
                }
            }
            onceEvent = false
            this.$router.push({ path: localLanguage+routerPath + paramsStr },onComplete => {},onAbort => {})
        } else {
            onceEvent = false
            this.$router.push({ path: `${localLanguage+routerPath}` },onComplete => {},onAbort => {})
        }
        // 由于单页面应用在切换路由后main.js中的变量仍会保留 一次事件 的状态 因此需要重置 不断切换暂时设置为500毫秒
        setTimeout(() => {
            onceEvent = true
        },500)
    }
}
Vue.prototype.urlSkip = function(routerPath) {
    // 传入的第一个路径参数会替换当前最后一个路径参数 如果原来路径为*/a 传入的为b/c，则url替换为*/b/c 因此需要用相对路径进行控制
    // 参数对象的属性需要在router中命名/:参数 可选参数则为/:参数?
    // 跳转后的取值为this.$route.params

   let localLanguage=localLanguageVal()
    console.log(localLanguage)
    console.log(arguments)
        if (arguments.length > 0) {
            let paramsStr = ''
            for (let index in arguments) {
                if (index > 0) {
                    encodeURIComponent(arguments[index])
                    let str = '/' + arguments[index]
                    paramsStr += str
                }
            }
            onceEvent = false
            location.href= "/#/"+localLanguage+routerPath + paramsStr
            // this.$router.push({ path: routerPath + paramsStr },onComplete => {},onAbort => {})

    }
}
Vue.prototype.$t = function(data) {
return i18n.messages[i18n.locale][data]
}
Vue.prototype.$loading = {
    show(){document.getElementById("loading").style.display="block"},
    hide(){document.getElementById("loading").style.display="none"},
}
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
    ak: 'CMQvk5Yn4eWaT4b5USNyvXaN2cFiCE8n'
})
// 引入全局路由守卫
import '@/utils/permission'

import VueI18n from 'vue-i18n'
import request from "./api/request";
Vue.use(VueI18n)
const i18n = new VueI18n({
    // locale: LangStorage.getLang('zh'),  // 语言标识，后面会用做切换和将用户习惯存储到本地浏览器
    locale: 'cn', // 语言标识
    messages: {
        'cn': require('@/components/language/zh'),
        'en': require('@/components/language/en')
    },
})
export default i18n


Vue.config.productionTip = false
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

var _hmt = _hmt || [];
(function() {
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?29860967a7bddc5cf8669e7c64d944fa";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
})();
/*
           * 直接触发PV
           * monitorPV({ category:'pc', page: 'home' });
           *
           * 监测事件添加
           * monitorAdd({ obj: $('#button'), category:'pc', action:'click', page: 'home', label: 'submit_button' });
           *
           * 直接触发监测
           * monitorPush({ category:'pc', action:'click', page: 'home', label: 'submit_button' });
           */

export function monitorPV(option) {
    if (option) {
        var category = option.category || '监测';
        var item = option.page || '';
        _hmt.push(['pageview', category, item]);
        if (window.console)
            console.log('pageview', category, item);
    }
}

export function monitorAdd(option) {
    if (option) {
        var obj = option.obj;
        var action = option.action || 'click';
        if (obj && obj.length > 0)
            obj.each(function (i) {
                $(this).on(action, option, monitorHandler);
            });
    }
}
export function monitorHandler(e) {
    var data = e.data;
    monitorPush(data);
}
export function monitorPush(data) {
    if (data) {
        var category = data.category || '监测';
        var action = data.action || 'click';
        var page = data.page || '';
        var label = data.label || '';
    }
    _hmt.push(["_trackEvent", category, action, page + "-" + label]);
    if (window.console)
        console.log('目录：' + category + ' | ' + '行为：' + action + ' | ' + '页面：' + page + ' | ' + '标签：' + label);
}
